import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BrowserRecommendation from './components/BrowserRecommendation';
import Home from './pages/Home';
import Info from './pages/Info';
import CalendarPage from './pages/CalendarPage';
import Todo from './pages/ThingsToDo';
import Login from './pages/Login';
import Register from './pages/Register';
import ChatbotPage from './pages/ChatbotPage';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<React.Fragment>
          <BrowserRecommendation />
          <Home />
        </React.Fragment>} />
        <Route path="/info" element={<Info />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/todo" element={<Todo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/chat" element={<ChatbotPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
